import styled from "styled-components"

export const CanvasContainer = styled.div`
  width: 100%;
  height: 50rem;
  background: ${(p) => p.theme.colors.greyLighter};
  border-radius: 0.6rem;
  margin: 0 1rem 0.8rem 1rem;

  /* React Flow injects its own min width for node handles — keep them subtle. */
  .react-flow__handle {
    opacity: 0;
  }
`

export const LoadingContainer = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${(p) => p.theme.colors.greyDarker};
  font-size: 1.2rem;
`
